import { fetchProfile } from '../api.js';
import { refreshProducts } from './products.js';
import { refreshAds } from './advertisements.js';
import { refreshCabinets, fetchLocations, selectCabinet } from './cabinets.js';
import { fetchOrganizationAlarms } from './cabinetAlarms.js';
import { refreshDevices } from './encodingDevices.js';
import { resetCabinetInventory } from './inventory.js';
import { resetReports } from './report.js';
import { refreshVatCategories } from './vatCategories.js';
import { storeSelectedGroup, getStoredSelectedGroup } from '../localStorage.js';
import { refreshDiscounts } from './discounts';
import { refreshProductCategories } from './productCategories.js';
import { refreshProductLabels } from './productLabels.js';
import { refreshSuppliers } from './suppliers.js';
import { refreshOrgSettings } from './organizations';
import { refreshOrganizationReleaseVersions } from './releaseVersions';
import { refreshRefillPlans } from './refillPlans.js';
import { resetAnalyticsData, resetCustomQueryData } from './analytics.js';
export const SIGN_IN_REJECTED = 'SIGN_IN_REJECTED';
export const AUTH_DATA_RECEIVED = 'AUTH_DATA_RECEIVED';
export const PROFILE_DATA_RECEIVED = 'PROFILE_DATA_RECEIVED';
export const REDIRECTING_TO_AUTHORIZATION_PAGE = 'REDIRECTING_TO_AUTHORIZATION_PAGE';
export const SIGN_OUT_USER = 'SIGN_OUT_USER';
export const SELECT_GROUP = 'SELECT_GROUP';

/**
 * Profile data received Redux action creator
 */
function profileDataReceived(profile) {
    return {
        type: PROFILE_DATA_RECEIVED,
        profile,
    };
}

function selectGroup(group) {
    storeSelectedGroup(group);

    return {
        type: SELECT_GROUP,
        group: group,
    };
}

/**
 * Empty filters when (client) group is changed
 */
function emptyFilters() {
    window.localStorage.setItem('dashboardDateRange', 'Last 7 days');
    window.localStorage.setItem('dashboardFilter', null);
}

export function handleGroupChange(group) {
    emptyFilters();
    return dispatch => {
        dispatch(selectGroup(group));
        dispatch(fetchLocations());
        dispatch(refreshProducts());
        dispatch(refreshAds());
        dispatch(refreshCabinets());
        dispatch(fetchOrganizationAlarms());
        dispatch(refreshDevices());
        dispatch(resetCabinetInventory());
        dispatch(resetReports());
        dispatch(refreshVatCategories());
        dispatch(refreshDiscounts());
        dispatch(refreshProductCategories());
        dispatch(refreshProductLabels());
        dispatch(refreshSuppliers());
        dispatch(refreshOrgSettings());
        dispatch(refreshOrganizationReleaseVersions());
        dispatch(selectCabinet(null));
        dispatch(refreshRefillPlans());
        dispatch(resetAnalyticsData());
        dispatch(resetCustomQueryData());
    };
}

/**
 * Thunk sign in user action creator
 */
export function handleAuthSuccess() {
    return (dispatch) => {
        return fetchProfile()
            .then(userData => {
                // use stored selected group if set and user belongs to group
                const storedSelectedGroup = getStoredSelectedGroup();
                if (storedSelectedGroup && userData.groups.filter(group => group.Id === storedSelectedGroup.Id).length > 0) {
                    dispatch(selectGroup(storedSelectedGroup));
                } else {
                    const group = userData.groups && userData.groups.length > 0 ? userData.groups[0] : null;
                    dispatch(selectGroup(group));
                }

                dispatch(profileDataReceived(userData));
            });
    };
}
